import React from 'react';
import { X } from 'lucide-react';

const DeleteConfirmationPopup = ({ isOpen, onClose, onConfirm, itemName, productType }) => {
    if (!isOpen) return null;

    const isDigitalProduct = productType === 'DIGITAL' || productType === 'HYBRID';

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg p-6 w-full max-w-md">
                <div className="flex justify-between items-center mb-4">
                    <h4 className="text-xl font-bold text-[#191970]">Delete Confirmation</h4>
                    <button onClick={onClose} className="text-gray-500 bg-gray-100 hover:text-gray-700">
                        <X size={24} />
                    </button>
                </div>
                <p className="text-gray-600 mb-4">
                    Are you sure you want to delete this {itemName}? This action cannot be undone.
                </p>
                {isDigitalProduct && (
                    <div className="bg-yellow-50 border border-yellow-200 rounded-md p-3 mb-6">
                        <p className="text-yellow-800 text-sm font-medium">
                            ⚠️ Warning: All download links for this digital product will stop working immediately.
                        </p>
                    </div>
                )}
                <div className="flex justify-end space-x-4">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                    >
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteConfirmationPopup;